import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { ApiClient } from '../api/ApiClient';
import { paths } from '../utils/Router/RoutePaths';
import history from '../utils/history';

const Home: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    const defaultMockupsFetcher = async () => {
      const data = await ApiClient.getDefaultMockups();
      const randomElement = data[Math.floor(Math.random() * data.length)];
      const defaultMockupData = {
        mockupTitle: randomElement.title,
        mockupId: randomElement.id,
      };
      const basePath = paths.mockup(defaultMockupData.mockupTitle, defaultMockupData.mockupId);
      const newPath = location.search ? `${basePath}${location.search}` : basePath;
      history.push(newPath);
    };
    defaultMockupsFetcher();
  }, [location.search]);

  return <></>;
};

export default Home;
